export default {
      id: "speakerphone-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#speakerphone",
      toString: function () {
        return this.url;
      }
    }